module.exports = __webpack_public_path__ + "static/Muli-LightItalic-7bdeca64f0aae02e10fac0c5b4a0d7e5.woff2";